/** Fonction d'import de script asynchrone */
export var asyncImportScript = function asyncImportScript(src) {
  var defer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var scriptBlock = document.createElement('script');
  scriptBlock.src = src;
  if (defer) {
    scriptBlock.defer = true;
  } else {
    scriptBlock.async = true;
  }
  document.head.appendChild(scriptBlock);
  return scriptBlock;
};